<template>
  <section class="categories">
    <aside class="sidebar sidebar--desktop">
      <h2 class="sidebar__title">Filtrar</h2>

      <div class="sidebar__test" v-if="!isSaleSolar">
        <div
          class="sidebar__options"
          v-for="(filtro, index) in filtros"
          :key="index"
        >
          <ul class="sidebar__nav">
            <h2>{{ filtro.tipo }}</h2>
            <li
              class="sidebar__item"
              v-for="f in filtro"
              :key="f.valor"
              @click="filtroClick(filtro.tipo, f.valor)"
            >
              {{ f.valor }}
            </li>
          </ul>
        </div>
      </div>

      <div class="sidebar__test" v-if="isSaleSolar && !canalCategoria">
        <div
          class="sidebar__options"
          v-for="(filtro, index) in filtrosSolar"
          :key="index"
        >
          <ul class="sidebar__nav">
            <h2>{{ filtro.tipo }}</h2>
            <li
              class="sidebar__item"
              v-for="f in filtro"
              :key="f.valor"
              @click="filtroClick(filtro.tipo, f.valor)"
            >
              {{ f.valor }}
            </li>
          </ul>
        </div>
      </div>

      <div class="sidebar__test" v-if="canalCategoria">
        <div
          class="sidebar__options"
          v-for="(filtro, index) in filtrosAvulsos"
          :key="index"
        >
          <ul class="sidebar__nav">
            <h2>{{ filtro.tipo }}</h2>
            <li
              class="sidebar__item"
              v-for="f in filtro"
              :key="f.valor"
              @click="filtroClick(filtro.tipo, f.valor)"
            >
              {{ f.valor }}
            </li>
          </ul>
        </div>
      </div>
    </aside>

    <aside class="sidebar sidebar--mobile">
      <h2
        class="sidebar__title sidebar__title--mobile"
        @click="showFilter = !showFilter"
      >
        Filtrar
      </h2>

      <div class="sidebar__test" v-if="!isSaleSolar">
        <div
          class="sidebar__options"
          v-for="(filtro, index) in filtros"
          :key="index"
        >
          <ul class="sidebar__nav" v-if="showFilter">
            <h2>{{ filtro.tipo }}</h2>
            <li
              class="sidebar__item"
              v-for="f in filtro"
              :key="f.valor"
              @click="filtroClick(filtro.tipo, f.valor)"
            >
              {{ f.valor }}
            </li>
          </ul>
        </div>
      </div>

      <div class="sidebar__test" v-if="isSaleSolar && !canalCategoria">
        <div
          class="sidebar__options"
          v-for="(filtro, index) in filtrosSolar"
          :key="index"
        >
          <ul class="sidebar__nav" v-if="showFilter">
            <h2>{{ filtro.tipo }}</h2>
            <li
              class="sidebar__item"
              v-for="f in filtro"
              :key="f.valor"
              @click="filtroClick(filtro.tipo, f.valor)"
            >
              {{ f.valor }}
            </li>
          </ul>
        </div>
      </div>

      <div class="sidebar__test" v-if="canalCategoria">
        <div
          class="sidebar__options"
          v-for="(filtro, index) in filtrosAvulsos"
          :key="index"
        >
          <ul class="sidebar__nav" v-if="showFilter">
            <h2>{{ filtro.tipo }}</h2>
            <li
              class="sidebar__item"
              v-for="f in filtro"
              :key="f.valor"
              @click="filtroClick(filtro.tipo, f.valor)"
            >
              {{ f.valor }}
            </li>
          </ul>
        </div>
      </div>
    </aside>

    <div class="categories__product">
      <a-skeleton :loading="loading" active>
          <div class="product__void" v-if="!loading && infos.length == 0">
          <div>
            <h2>
              Desculpe, não encontramos nenhum resultado para sua busca :(
            </h2>
            <p>Recomendados que tente realizar uma nova busca.</p>
            <p>
              <router-link to="/">Voltar a página inicial</router-link>
            </p>
          </div>
        </div>
        <div class="product">
          <div
            class="product__list"
            v-for="(info, index) in infos"
            :key="index"
          >
            <a href="">
              <img
                loading="lazy"
                class="product__image"
                v-lazy="info.ImagemItem"
                :alt="info.Ds_Item"
              />
            </a>
            <p class="product__name">
              {{ info.Ds_Item }}
            </p>
            <div v-if="!isSolar" class="product__price">
              <span class="price__per" v-if="info._Disponivel >= 1">
                {{ (info.vl_liquido_produto * 0.95) | toCurrency }}
                <span class="price__AtSight">à vista</span></span
              >
              <span class="price__priceTerm">
                ou <span> {{ info.vl_liquido_produto | toCurrency }}</span>
              </span>
              <span class="price__plots" v-if="info.vl_liquido_produto > 221">
                10x de
                {{ (info.vl_liquido_produto / 10) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 195 &&
                  info.vl_liquido_produto < 220
                "
              >
                8x de
                {{ (info.vl_liquido_produto / 8) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 175 &&
                  info.vl_liquido_produto <= 194
                "
              >
                7x de
                {{ (info.vl_liquido_produto / 7) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 150 &&
                  info.vl_liquido_produto <= 174
                "
              >
                6x de
                {{ (info.vl_liquido_produto / 6) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 120 &&
                  info.vl_liquido_produto <= 149
                "
              >
                5x de
                {{ (info.vl_liquido_produto / 5) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 100 &&
                  info.vl_liquido_produto <= 119
                "
              >
                4x de
                {{ (info.vl_liquido_produto / 4) | toCurrency }}
                sem juros</span
              >
              <span
                class="price__plots"
                v-if="
                  info.vl_liquido_produto >= 80 && info.vl_liquido_produto <= 99
                "
              >
                3x de
                {{ (info.vl_liquido_produto / 3) | toCurrency }}
                sem juros</span
              >
              <span class="price__plots" v-if="info.vl_liquido_produto <= 79">
                2x de
                {{ (info.vl_liquido_produto / 2) | toCurrency }}
                sem juros</span
              >

              <span class="price__lower-quantity" v-if="info._Disponivel <= 5"
                >Poucas Unidades</span
              >
            </div>

            <!-- Exibe o valor dos produtos Solar -->
            <div v-else class="product__price">
              <span class="price__priceTerm" v-if="info._Disponivel >= 1">
                {{ info.vl_liquido_produto | toCurrency }}
              </span>
              <span class="price__per">
                {{
                  (info.vl_liquido_produto -
                    info.vl_liquido_produto * (info.DESCONTO_SOLAR / 100))
                    | toCurrency
                }}
                <span class="price__AtSight">à vista</span>
              </span>

              <span class="price__plots">
                Preço: de
                {{ moment(info.VALIDADE_DE).format("DD/MM/YYYY") }} até
                {{ moment(info.VALIDADE_ATE).format("DD/MM/YYYY") }}
              </span>
            </div>
            <div class="product__buttons">
              <button
                class="product__buttons--details"
                @click="
                  productDetails(
                    info.Nr_TabelaPrecoItem,
                    info.vl_liquido_produto,
                    info.isCustomized
                  )
                "
              >
                <i class="fa fa-eye" aria-hidden="true"></i> Detalhes
              </button>

              <button
                v-if="!isSaleSolar || (isSaleSolar && !info.isCustomized)"
                class="product__buttons--buy"
                @click="addMiniCart(info)"
              >
                <i class="fa fa-shopping-cart" aria-hidden="true"></i> +
                Carrinho
              </button>
            </div>
          </div>
        </div>
      </a-skeleton>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import util from "../../util/util";

export default {
  data() {
    return {
      infos: null,
      loading: false,
      filtros: null,
      filtrosSolar: null,
      filtrosAvulsos: null,
      showFilter: false,
      nomeCategoria: null,
      linkDaPagina: null,
      isSolar: null,
      isSaleSolar: false,
      canalCategoria: false,
      canal: null,
      buscaPricing: [],
    };
  },

  async created() {
    this.linkDaPagina = window.location.href;
    this.isSaleSolar = JSON.parse(localStorage.getItem("isSaleSolar"));
  },

  metaInfo() {
    return {
      title: `${this.nomeCategoria} | Leveros Integra`,
      meta: [
        {
          name: "description",
          content: `Encontre seu ${this.nomeCategoria} no Leveros Integra. Temos diversas opções e variedades de ${this.nomeCategoria} esperando por você. Confira!`,
        },
        { name: "robots", content: "index,follow" },
        { name: "country", content: "BRA" },
        { name: "currency", content: "R$" },
        { name: "author", content: "Leveros Integra" },
        { name: "copyright", content: "Leveros Integra" },
        {
          property: "og:title",
          content: `${this.nomeCategoria} | Leveros Integra`,
        },
        {
          property: "og:description",
          content: `Encontre seu ${this.nomeCategoria} no Leveros Integra. Temos diversas opções e variedades de ${this.nomeCategoria} esperando por você. Confira!`,
        },
        { property: "og:site_name", content: "Leveros Integra" },
        { property: "og:author", content: "Leveros Integra" },
        { property: "og:url", content: `${this.linkDaPagina}` },
        { property: "og:type", content: "company" },
      ],
      link: [{ rel: "canonical", href: `${this.linkDaPagina}` }],
    };
  },

  methods: {
    productDetails(sku, preco, isCustomized) {
      localStorage.setItem(
        "precoDetails",
        JSON.stringify({ preco: preco, sku: sku })
      );

      const isSaleSolar = JSON.parse(localStorage.getItem("isSaleSolar"));

      // Controle de params
      let route = "";
      if (!isSaleSolar) {
        route = `details?sku=${sku}`;
      } else if (isCustomized && isSaleSolar) {
        route = `details?sku=${sku}&isCustomized=true&isSolar=true`;
      } else {
        route = `details?sku=${sku}&isSolar=true`;
      }

      window.location.href = route;
    },

    filtroClick(tipo, valor) {
      if (tipo == "Capacidade") {
        valor = valor + "-" + valor;
      }
      let url = window.location.href + "&" + tipo + "=" + valor;
      window.location.href = url;
    },

    addMiniCart(produto) {
      const isSaleSolar = JSON.parse(localStorage.getItem("isSaleSolar"));
      // Valida o Carrinho
      if (!util.validaItensCarrinhoSolar(produto)) {
        return alert(
          `\n \n Ops.. \n Não é possível incluir ao carrinho itens de Revenda (Avulsos) e Kit's`
        );
      }

      let totalItens = 0;

      // localStorage.setItem('carrinho', [])
      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];
      let productAdd = {
        sku: produto.Nr_TabelaPrecoItem,
        nomeItem: produto.Ds_Item,
        imagem: produto.ImagemItem,
        quantidade: 1,
        marca: produto.Marca,
        valor: produto.vl_liquido_produto,
        estoque: produto._Disponivel,
        isCustomized: produto.isCustomized,
        isSolar: isSaleSolar,
      };

      if (carrinho.length > 0) {
        let validarItem = carrinho.find((x) => x.sku == productAdd.sku);
        if (validarItem != undefined && validarItem != null) {
          carrinho.forEach(function (e) {
            if (e.sku == productAdd.sku) {
              if (e.quantidade < productAdd.estoque) {
                e.quantidade = e.quantidade + 1;
              }
            }
          });
        } else {
          carrinho.push(productAdd);
        }
      } else {
        carrinho.push(productAdd);
      }
      carrinho.forEach(function (e) {
        totalItens = parseFloat(totalItens) + parseFloat(e.quantidade);
      });
      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      document.getElementsByClassName("header__quantity")[0].innerText =
        totalItens;
      document.getElementsByClassName("header__cart")[0].click();
    },

    async getDados() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));
        let canal = JSON.parse(localStorage.getItem("saleChannel"));
        let solar = JSON.parse(localStorage.getItem("isSaleSolar"));

        this.canal = canal;

        if (dados != undefined) {
          this.token = dados.token;
        } else {
          this.token = "";
        }

        var url = new URL(window.location.href);
        var categoria = url.searchParams.get("Categoria");
        var marca = url.searchParams.get("Marca");
        var Ciclo = url.searchParams.get("Ciclo");
        var Capacidade = url.searchParams.get("Capacidade");
        var Tensao = url.searchParams.get("Tensão")
          ? url.searchParams.get("Tensão")
          : url.searchParams.get("Voltagens");
        var TipoGas = url.searchParams.get("Gás Refrigerante");
        var solarCategoria = url.searchParams.get("Categorias");
        var inversorSolar = url.searchParams.get("Faixa de Potência");
        var geradorSolar = url.searchParams.get("Tipo de Gerador");
        this.nomeCategoria = categoria;

        if (categoria === "Itens Avulsos") {
          this.canalCategoria = true;
        }

        // Passa a tabela de preço caso seja solar -- ou valida se o usuário possui o Sales Channel 26
        if (categoria == "Kit Energia Fotovoltaica") {
          // var tabelaPreco = canal;
          this.isSolar = true;
        }

        try {
          this.loading = true;
          let body = {
            Categoria: categoria,
            Ciclo: Ciclo,
            Marca: marca,
            Capacidade: Capacidade,
            Tensao: Tensao,
            TipoGas: TipoGas,
            categoriaSolar: solarCategoria,
            faixaInversor: inversorSolar,
            tipoGerador: geradorSolar,
            TabelaPreco: canal,
            isSaleSolar: solar,
          };
          const response = await axios({
            method: "post",
            data: body,
            url: `https://www.leverosintegra.com.br/map/Api/ProdutoLista?token=${this.token}`,
          });

          this.infos = response.data.lcardapio;

          const responseData = await axios.get(
            "https://pricing-api.leverosservicos.com.br/price/solar"
          );

          for (let i = 0; i < this.infos.length; i++) {
            let refId = this.infos[i].REFID;
            let datas = responseData.data.find((i) => i.productId == refId);

            this.infos[i].VALIDADE_ATE =
              datas != undefined ? datas.finalDate : null;
            this.infos[i].VALIDADE_DE =
              datas != undefined ? datas.initialDate : null;
          }

          let filtroAvulso = [];

          let marcasAvulsos = response.data.lcardapio.map((x) => x.Marca);

          let parametroAvulso = [];
          marcasAvulsos.forEach(function (m) {
            let _parametro = {
              valor: m,
            };
            if (parametroAvulso == null) {
              parametroAvulso.push(_parametro);
            } else if (parametroAvulso.find((s) => s.valor == m) == undefined) {
              parametroAvulso.push(_parametro);
            }
          });
          filtroAvulso.push(parametroAvulso);
          filtroAvulso[0].tipo = "Marca";

          this.filtrosAvulsos = filtroAvulso;

          let filtros = [];

          //Filtro de Marcas
          let marcas = response.data.lcardapio.map((x) => x.Marca);
          let capacidade = response.data.lcardapio.map(
            (x) => x.CAPACIDADE_NUMBER
          );
          let gasRefrigerante = response.data.lcardapio.map(
            (x) => x.GAS_REFRIGERANTE
          );
          let voltagem = response.data.lcardapio.map((x) => x.Voltagem);
          let ciclo = response.data.lcardapio.map((x) => x.Ciclo);

          //Marca
          let parametro = [];
          marcas.forEach(function (m) {
            let _parametro = {
              valor: m,
            };
            if (parametro == null) {
              parametro.push(_parametro);
            } else if (parametro.find((s) => s.valor == m) == undefined) {
              parametro.push(_parametro);
            }
          });
          filtros.push(parametro);
          filtros[0].tipo = "Marca";

          //Capacidade
          parametro = [];
          capacidade.forEach(function (m) {
            let _parametro = {
              valor: m,
            };
            if (parametro == null) {
              parametro.push(_parametro);
            } else if (parametro.find((s) => s.valor == m) == undefined) {
              parametro.push(_parametro);
            }
          });
          filtros.push(parametro);
          filtros[1].tipo = "Capacidade";

          //Ciclo
          parametro = [];
          ciclo.forEach(function (m) {
            let _parametro = {
              valor: m,
            };
            if (parametro == null) {
              parametro.push(_parametro);
            } else if (parametro.find((s) => s.valor == m) == undefined) {
              parametro.push(_parametro);
            }
          });
          filtros.push(parametro);
          filtros[2].tipo = "Ciclo";

          //Gás Refrigerante
          parametro = [];
          gasRefrigerante.forEach(function (m) {
            let _parametro = {
              valor: m,
            };
            if (parametro == null) {
              parametro.push(_parametro);
            } else if (parametro.find((s) => s.valor == m) == undefined) {
              parametro.push(_parametro);
            }
          });
          filtros.push(parametro);
          filtros[3].tipo = "Gás Refrigerante";

          //Voltagem
          parametro = [];
          voltagem.forEach(function (m) {
            let _parametro = {
              valor: m,
            };
            if (parametro == null) {
              parametro.push(_parametro);
            } else if (parametro.find((s) => s.valor == m) == undefined) {
              parametro.push(_parametro);
            }
          });
          filtros.push(parametro);
          filtros[4].tipo = "Voltagem";

          this.filtros = filtros;

          let filtrosSolar = [];

          //Filtro de Marcas
          let categorias = response.data.lcardapio.map((x) => x.categoriaSolar);
          let marcaSolar = response.data.lcardapio.map((x) => x.Marca);
          let inversor = response.data.lcardapio.map((x) => x.faixaInversor);
          let gerador = response.data.lcardapio.map((x) => x.tipoGerador);
          let voltagemSolar = response.data.lcardapio.map((x) => x.Voltagem);

          //Marca
          let parametrosSolar = [];
          categorias.forEach(function (m) {
            let _parametrosSolar = {
              valor: m,
            };
            if (parametrosSolar == null) {
              parametrosSolar.push(_parametrosSolar);
            } else if (parametrosSolar.find((s) => s.valor == m) == undefined) {
              parametrosSolar.push(_parametrosSolar);
            }
          });
          filtrosSolar.push(parametrosSolar);
          filtrosSolar[0].tipo = "Categorias";

          //Categoria
          parametrosSolar = [];
          marcaSolar.forEach(function (m) {
            let _parametrosSolar = {
              valor: m,
            };
            if (parametrosSolar == null) {
              parametrosSolar.push(_parametrosSolar);
            } else if (parametrosSolar.find((s) => s.valor == m) == undefined) {
              parametrosSolar.push(_parametrosSolar);
            }
          });
          filtrosSolar.push(parametrosSolar);
          filtrosSolar[1].tipo = "Marca";

          //Inversor
          parametrosSolar = [];
          inversor.forEach(function (m) {
            let _parametrosSolar = {
              valor: m,
            };
            if (parametrosSolar == null) {
              parametrosSolar.push(_parametrosSolar);
            } else if (parametrosSolar.find((s) => s.valor == m) == undefined) {
              parametrosSolar.push(_parametrosSolar);
            }
          });
          filtrosSolar.push(parametrosSolar);
          filtrosSolar[2].tipo = "Faixa de Potência";

          //Gerador
          parametrosSolar = [];
          gerador.forEach(function (m) {
            let _parametrosSolar = {
              valor: m,
            };
            if (parametrosSolar == null) {
              parametrosSolar.push(_parametrosSolar);
            } else if (parametrosSolar.find((s) => s.valor == m) == undefined) {
              parametrosSolar.push(_parametrosSolar);
            }
          });
          filtrosSolar.push(parametrosSolar);
          filtrosSolar[3].tipo = "Tipo de Gerador";

          // Voltagem
          parametrosSolar = [];
          voltagemSolar.forEach(function (m) {
            let _parametrosSolar = {
              valor: m,
            };
            if (parametrosSolar == null) {
              parametrosSolar.push(_parametrosSolar);
            } else if (parametrosSolar.find((s) => s.valor == m) == undefined) {
              parametrosSolar.push(_parametrosSolar);
            }
          });
          filtrosSolar.push(parametrosSolar);
          filtrosSolar[4].tipo = "Voltagens";

          this.filtrosSolar = filtrosSolar;

          this.loading = false;
        } catch (e) {
          console.log("erro", e);
        }
      } catch (e) {
        console.log(e);
      }
    },
  },

  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.categories {
  max-width: 100%;
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  flex-direction: column;

  @media (min-width: 769px) {
    max-width: 83%;
    flex-direction: row;
  }

  @media (min-width: 1920px) {
    max-width: 70%;
  }

  .sidebar {
    background: var(--customGray-70);
    border-radius: 5px;
    padding: 15px;

    &--mobile {
      display: block;
      min-width: 100%;
      border-radius: 0;
      margin-bottom: 25px;

      @media (min-width: 769px) {
        display: none;
      }
    }

    &--desktop {
      display: none;

      @media (min-width: 769px) {
        display: block;
        width: 25%;
      }
    }

    &__title {
      font-size: 1.4rem;
      color: var(--standardGreen);

      &--mobile {
        &::after {
          content: "(Abrir/Fechar Filtros)";
          position: relative;
          left: 10px;
          font-size: 0.85rem;
          vertical-align: middle;
          color: var(--customBlue);
        }
      }
    }

    &__options {
      h2 {
        font-size: 1.1rem;
        color: var(--customDarkGreen);
        padding: 20px 0 10px 0;
      }
    }

    &__item {
      list-style: none;
      cursor: pointer;
      padding: 5px 0;
      color: var(--customDarkGreen);
      font-size: 1rem;

      &:hover {
        color: var(--customGray-500);
      }
    }
  }

  &__product {
    width: 100%;
    margin-left: 0;

    @media (min-width: 769px) {
      margin-left: 20px;
    }
  }
}

.product {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  color: var(--customGray-500);

  &__void {
    width: 90%;
    margin: 0 auto;
    padding: 20px;
    background: var(--customGray-70);
    border-radius: 5px;

    h2 {
      color: var(--standardGreen);
      padding-bottom: 20px;
      font-size: 1.2rem;
    }

    p {
      a {
        color: var(--customGray-500);
        padding-top: 20px;
      }
    }
  }

  &__list {
    margin: 5px;
    border: 1px solid var(--customGray-100);
    border-radius: 5px;
    padding: 25px 0;
    width: 100%;

    @media (min-width: 321px) and (max-width: 768px) {
      width: 48%;
      margin: 3px;
    }

    @media (min-width: 769px) {
      width: 32%;
    }

    &:hover {
      border: 1px solid var(--standardGreen);
      background: linear-gradient(
        10deg,
        rgba(0, 90, 100, 0.2839110644257703) 0%,
        rgba(0, 90, 100, 0.014) 45%
      );
    }
  }

  a {
    display: flex;
    justify-content: center;
  }

  &__image {
    max-width: 220px;
    height: auto;
  }

  &__name {
    text-align: center;
    padding-bottom: 20px;
    font-size: 1rem;
  }

  &__price {
    display: flex;
    flex-direction: column;
    padding-left: 10px;

    @media (min-width: 441px) {
      padding-left: 15px;
    }

    .price {
      &__per {
        color: var(--standardGreen);
        font: 700 1.3rem "Soleto", sans-serif;
      }

      &__AtSight {
        font-size: 0.85rem;
      }

      &__priceTerm {
        padding: 3px 0;
        font-size: 0.95rem;
      }

      &__plots {
        font-size: 0.95rem;
      }

      &__lower-quantity {
        background-color: #ff000030;
        border-radius: 2px;
        width: 90%;
        margin: 15px 0 0 0;
        padding: 3px 0;
        text-align: center;
        font-size: 0.85rem;
      }
    }
  }

  &__buttons {
    padding-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column-reverse;

    @media (min-width: 1309px) {
      flex-direction: row;
    }

    &--details {
      border: 1px solid var(--customDarkGreen);
      border-radius: 5px;
      color: var(--customDarkGreen);
      font-size: 0.95rem;
      outline: none;
      margin: 10px 3px;
      width: 95%;
      padding: 11px;

      @media (min-width: 1309px) {
        margin: 0 10px;
        padding: 7px;
        width: initial;
      }
    }

    &--buy {
      background-color: var(--standardGreen);
      border-radius: 5px;
      color: var(--customWhite);
      font: 700 0.95rem "Soleto", sans-serif;
      outline: none;
      width: 95%;
      padding: 13px;

      @media (min-width: 1309px) {
        width: initial;
        padding: 7px;
      }
    }
  }
}
</style>